.input {
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #ced4da;
  font-size: 16px;
  padding: 10px 26px 10px 12px;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
}

.input:focus {
  border-radius: 4px;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  outline: none;
}

.actionButton {
  width: 100%;
}

.formSelect {
  min-width: 100%;
}

.formSelect label {
  background-color: #fff;
}

.grayBackground {
  background: #e2e1e1;
}

.responseDiv {
  flex-grow: 1;
}

.responseDiv h3 {
  margin: 0;
  padding: 8px;
}

.responseDiv h4 {
  margin: 0;
  padding: 11.2px;
}

.responseAction {
  display: flex;
}

.responseAction button {
  flex: 1;
}

.responseAction button:first-child {
  margin-right: 8px;
}

.responseAction button:last-child {
  margin-left: 8px;
}

.commandButton button {
  text-transform: none;
}

.rawInput {
  border: 1px solid #a7a6a6;
  width: 100%;
  padding-left: 8px;
}

.topMargin {
  margin-top: 32px;
}

.disabledInput {
  background: #e2e1e1;
  border: 1px solid #e2e1e1;
  font-size: 1rem;
  color: #000 !important;
  padding: 4px 0 4px 8px;
  font-weight: bold;
}

.debugView {
  position: absolute;
  background: #fff;
  z-index: 1;
  max-height: 500px;
  overflow: auto;
  border: 1px solid #e2e1e1;
}

.handIcon {
  cursor: pointer;
}

.heading {
  font-size: 15px;
}

.secondaryHeading {
  font-size: 12px;
  color: #666;
}

.icon {
  vertical-align: bottom;
  height: 20px;
  width: 20px;
}

.details {
  align-items: center;
}

.column {
  flex-basis: 33.33%;
}

.columnLeft {
  flex-basis: 33.33%;
  float: right;
}

.helper {
  border-left: 2px solid #e0e0e0;
  padding: 8px 16px;
}

.link {
  color: #1976d2;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.accordionTriggerContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 8px;
}

.destAcctRow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 16px;
}

.destAcctFlex {
  flex: 1;
}

.noteText {
  padding-top: 4px;
}

.savePrefButton {
  padding-top: 8px;
}
